<template>
  <v-navigation-drawer
    v-model="showDrawer"
    app
    class="app-drawer"
    :mini-variant.sync="mini"
    mini-variant-width="64"
    :width="drawerWidth"
  >
    <v-toolbar color="primary darken-1" dark>
      <img :src="computeLogo" height="70" alt="Themis" />
      <v-toolbar-title>
        <span class="hidden-sm-and-down">Themis</span>
      </v-toolbar-title>
    </v-toolbar>
    <vue-perfect-scrollbar class="app-drawer__scrollbar">
      <div>
        <nav-list :items="computeMenu" :mini="mini" />
      </div>
    </vue-perfect-scrollbar>
    <template #append>
      <div class="grey lighten-3">
        <template v-if="mini">
          <v-btn
            block
            width="64"
            height="48"
            icon
            tile
            class="mx-auto"
            @click="handleDrawerCollapse"
          >
            <v-icon>mdi-arrow-collapse-right</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            right
            block
            height="48"
            icon
            tile
            @click="handleDrawerCollapse"
          >
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </v-btn>
        </template>
      </div>
    </template>
  </v-navigation-drawer>
</template>
<script>
import routes from "@/router/paths"
import NavList from "@/components/nav/NavList"
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { GET_LOGO } from "@/store/actions/client"
import { mapActions } from "vuex"

export default {
  name: "AppDrawer",
  components: { VuePerfectScrollbar, NavList },
  props: {},
  data() {
    return {
      mini: false,
      showDrawer: true,
      drawerWidth: 256,
      scrollSettings: {
        maxScrollbarLength: 160,
      },
    }
  },

  computed: {
    computeLogo() {
      let logo = "data:image/png;base64," + this.logo
      if (logo === undefined) {
        return "/icons/logo.gif"
      }
      return logo
    },
    computeMenu() {
      return this.filterRouteItem(routes)
    },
    logo() {
      return this.$store.state.client.client.logo
    },
    computeHeight() {
      return {
        height: this.height || "",
      }
    },
  },
  mounted() {
    if (this.logo === undefined) {
      this.GET_LOGO({ url: location.protocol + "//" + location.host })
    }
  },

  methods: {
    ...mapActions("client", [GET_LOGO]),
    filterRouteItem(routes) {
      return routes
        .filter((item) => item.menu === true)
        .map((item) => {
          return {
            title: this.$tc("main-nav." + item.name, 2),
            icon: item.meta.icon,
            img: item.meta.img,
            restricted: item.meta.restricted,
            path: item.path,
            isNew: item.meta.isNew || false,
            children: item.children ? this.filterRouteItem(item.children) : [],
          }
        })
    },
    handleDrawerCollapse() {
      this.mini = !this.mini
    },
    toggleDrawer() {
      this.showDrawer = !this.showDrawer
    },
  },
}
</script>

<style lang="sass" scoped>
.app-drawer
  &__srollbar
    max-height:  calc(100vh - 64px - 36px - 44px)
  &__inner
    height: calc(100vh - 64px - 36px - 44px)
</style>
